import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "./hero.css";

function Hero() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("heroPage.metaTitolo")}</title>
        <meta name="description" content={t("heroPage.metaDescrizione")} />
        <meta name="keywords" content="sviluppo siti web Lecce, e-commerce Puglia, web app responsive, sviluppo software Lecce, programmatore freelance Lecce, sviluppo web professionale, siti web ottimizzati SEO, software gestionali personalizzati, web agency Lecce, sviluppo applicazioni web" />
        <link rel="canonical" href="https://www.andromedaprog.it/" />
        <meta property="og:title" content={t("heroPage.ogTitolo")} />
        <meta property="og:description" content={t("heroPage.ogDescrizione")} />
        <meta property="og:image" content={t("heroPage.ogImage")} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={t("heroPage.ogLocale")} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Home",
            url: "https://www.andromedaprog.it/",
            description: t("heroPage.ldJsonDescrizione")
          })}
        </script>
      </Helmet>

      <section
        id="hero"
        className="hero d-flex align-items-center text-center text-light"
        style={{
          backgroundImage: `url(${t("heroPage.ogImage")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container" data-aos="fade-up">
          <h1 className="display-5 fw-bold mb-3">{t("heroPage.titolo")}</h1>
          <p className="lead mb-4">{t("heroPage.sottotitolo")}</p>

          <ScrollLink
            to="contatti"
            smooth={true}
            duration={700}
            offset={-90}
            className="btn btn-primary btn-lg shadow"
            aria-label={t("heroPage.cta")}
            title={t("heroPage.cta")}
          >
            {t("heroPage.cta")}
          </ScrollLink>
        </div>
      </section>
    </>
  );
}

export default Hero;
